/* ============================================================
   Studio Nadee — Contact Page JS
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. HONEYPOT
     ---------------------------------------------------------- */
  const form     = document.getElementById('contact-form');
  const honeypot = form && form.querySelector('[name="contact[bot_field]"]');
  if (form && honeypot) {
    form.addEventListener('submit', function () {
      honeypot.value = '';
    });
  }

  /* ----------------------------------------------------------
     2. ORDER ROW — show/hide based on subject dropdown
     ---------------------------------------------------------- */
  const subjectSelect = document.getElementById('contact_subject');
  const orderRow      = document.getElementById('orderRow');

  if (subjectSelect && orderRow) {
    const ORDER_TOPICS = ['My order', 'Returns & exchanges'];

    function toggleOrderRow() {
      const show = ORDER_TOPICS.includes(subjectSelect.value);
      if (show) {
        orderRow.removeAttribute('hidden');
      } else {
        orderRow.setAttribute('hidden', '');
      }
    }

    subjectSelect.addEventListener('change', toggleOrderRow);
    toggleOrderRow();
  }

  /* ----------------------------------------------------------
     3. FAQ ACCORDION
     ---------------------------------------------------------- */
  const faqList = document.getElementById('faqList');

  if (faqList) {
    faqList.addEventListener('click', function (e) {
      const trigger = e.target.closest('.faq-item__trigger');
      if (!trigger) return;

      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const panelId  = trigger.getAttribute('aria-controls');
      const panel    = document.getElementById(panelId);
      if (!panel) return;

      if (expanded) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        panel.addEventListener('transitionend', function onEnd() {
          panel.setAttribute('hidden', '');
          panel.removeEventListener('transitionend', onEnd);
        });
      } else {
        // Close any currently open item
        faqList.querySelectorAll('.faq-item__trigger[aria-expanded="true"]')
          .forEach(function (openTrigger) {
            if (openTrigger === trigger) return;
            const openPanelId = openTrigger.getAttribute('aria-controls');
            const openPanel   = document.getElementById(openPanelId);
            openTrigger.setAttribute('aria-expanded', 'false');
            if (openPanel) {
              openPanel.classList.remove('is-open');
              openPanel.addEventListener('transitionend', function onEnd() {
                openPanel.setAttribute('hidden', '');
                openPanel.removeEventListener('transitionend', onEnd);
              });
            }
          });

        // Open this item
        panel.removeAttribute('hidden');
        panel.getBoundingClientRect(); // force reflow
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }

})();
